export const LS_USER_FEEDBACK_SUBMISSION_TIME_KEY =
  'LS_USER_FEEDBACK_SUBMISSION_TIME_KEY';
